import gql from 'graphql-tag';

export const getGameOptionRegionListing = gql`query{
    getGameOptionRegionListing {
        edges {
            node {
                id
                name
            }
        }
    }
}`;

export const getGameOptionStepListing = gql`query{
    getGameOptionStepListing(sortBy: "o_index", sortOrder: "ASC") {
        totalCount
        edges {
            node {
                id
                key
                name
                description
                icon
                index
                gameOptions {
                    ... on fieldcollection_GameOptionNumberRange {
                        uniqueId
                        maxValue
                    }
                    ... on fieldcollection_GameOptionQuantityValue {
                        uniqueId
                        quantity {
                            value
                            unit {
                                id
                                abbreviation
                            }
                            toString
                        }
                        garden
                        hipRoof
                        windowQuantity
                    }
                    ... on fieldcollection_GameOptionSelection {
                        uniqueId
                        input
                    }
                    ... on fieldcollection_GameOptionRegion {
                        uniqueId
                        region
                    }
                }
            }
        }
    }
}`;
